import React, { useEffect, useState } from 'react';
import InvestorInvestTableSC from './investor-invest-table.styled';
import { SmallText } from '../../typography';
import InstallmentItem from './invest-item';

import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import useWindowSize from '../../../utils/screen-size';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';

const InvestorInvestTable = ({ instructionHistory }) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;

  const [latestInstructionChangeId, setLatestInstructionChangeId] = useState('');
  const [latestDepositId, setLatestDepositId] = useState('');

  useEffect(() => {
    let onlyDeposit = [];
    let onlyChangeInstruction = [];
    let latestDepositId = '';
    let latestChangeId = '';

    if (instructionHistory && instructionHistory.length) {
      onlyDeposit = [
        ...instructionHistory
          .filter((item) => item.type === 'deposit')
          .sort((a, b) => a.created_at > b.created_at),
      ];
      onlyChangeInstruction = [
        ...instructionHistory
          .filter((item) => item.type === 'investment_instruction_change')
          .sort((a, b) => a.created_at > b.created_at),
      ];

      latestDepositId = onlyDeposit.length - 1;
      latestChangeId = onlyChangeInstruction.length - 1;

      if (latestChangeId !== -1) {
        setLatestInstructionChangeId(onlyChangeInstruction[latestChangeId].id);
      }
      if (latestDepositId !== -1) {
        setLatestDepositId(onlyDeposit[latestDepositId].id);
      }
    }
  }, [instructionHistory]);

  return (
    <>
      <InvestorInvestTableSC>
        {isTablet ? null : (
          <thead>
            <tr>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_invest_manage_invest_table_head_1"
                    defaultMessage={dlt['investor_invest_manage_invest_table_head_1']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_invest_manage_invest_table_head_2"
                    defaultMessage={dlt['investor_invest_manage_invest_table_head_2']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_invest_manage_invest_table_head_3"
                    defaultMessage={dlt['investor_invest_manage_invest_table_head_3']}
                  />
                </SmallText>
              </th>
              <th></th>
            </tr>
          </thead>
        )}

        <tbody>
          {instructionHistory.map((item, i) => {
            return (
              <InstallmentItem
                isFirstChange={item.id === latestInstructionChangeId}
                isFirstDeposit={item.id === latestDepositId}
                key={item.id}
                type={item.type}
                amount={item.amount ? item.amount : null}
                totalAmount={item.total_amount ? item.total_amount : null}
                maxInvestment={item.max_investment}
                date={item.created_at}
                reinvest={item.reinvest_rate ? item.reinvest_rate : false}
                isTablet={isTablet}
              />
            );
          })}
        </tbody>
      </InvestorInvestTableSC>
    </>
  );
};

export default InvestorInvestTable;
